var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSocialPrint = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13.853,
    viewBox: "0 0 16 13.853",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_zocial-print",
    "data-name": "Icon zocial-print",
    d: "M.18,17.813V12.047L2.189,9.813H3.661v1.108h-.97L1.306,12.462V16.7H15.072V12.462l-1.385-1.541h-.97V9.813h1.472l1.991,2.234v5.766H.18Zm3.481-5.524V6.575L6.275,3.96h6.442v8.329H3.661ZM4.7,11.233h6.978V5H7.314V7.614H4.7Z",
    transform: "translate(-0.18 -3.96)",
    fill: "#1976d2"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSocialPrint);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/social-print.91477b770cd59f1aa28a9255800b0966.svg";